export enum IStatusProcesso {
    PENDENTE = 1,
    PROCESSANDO = 2,
    PROCESSADO = 3,
    FALHA = 4
}